const notEmpty = (value) => {
  if (value === undefined || value === null) return false;

  if (typeof (value) === 'number' || typeof (value) === 'boolean') return true;

  // empty Array / String case
  if (value.length === 0) return false;

  return true;
};

export default notEmpty;
